import { Box, Link, Paper, Typography } from '@mui/material'

import { IPolicyOptantsResponse } from '../types'

export type PolicyOptantsRowKey = 'K10' | 'K11' | 'K12' | 'K13' | 'K20'

interface IProps {
  data: IPolicyOptantsResponse
  onRowClick?(code: PolicyOptantsRowKey): void
}

const fmt = new Intl.NumberFormat('pt-BR')

const CLICKABLE: PolicyOptantsRowKey[] = ['K10', 'K20']

export function PolicyOptants({ data, onRowClick }: IProps) {
  const rows: Array<{ label: string; value: number; code: PolicyOptantsRowKey }> = [
    { label: 'Exceções ativas', value: data.excecoes_ativas, code: 'K10' },
    { label: 'Exceções expirando em 30d', value: data.excecoes_expirando_30d, code: 'K11' },
    { label: 'Optantes livre-adesão', value: data.optantes_livre_adesao, code: 'K12' },
    { label: 'Sem resposta (livre-adesão)', value: data.sem_resposta_livre_adesao, code: 'K13' },
    { label: 'Não-optantes ativos', value: data.nao_optantes_ativos, code: 'K20' },
  ]
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      {rows.map(r => {
        const clickable = onRowClick && CLICKABLE.includes(r.code) && r.value > 0
        return (
          <Box key={r.code} sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5 }}>
            <Typography variant="body2">
              {clickable ? (
                <Link component="button" type="button" underline="hover" onClick={() => onRowClick!(r.code)}>
                  {r.label}
                </Link>
              ) : r.label}
              {' '}
              <Typography component="span" variant="caption" color="text.secondary">({r.code})</Typography>
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>{fmt.format(r.value)}</Typography>
          </Box>
        )
      })}
    </Paper>
  )
}
